import { Table, Input } from "antd";
import { AddHoliday } from "../../../components/modelpopup/AddHoliday";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { base_url } from "../../../base_urls";

const Holidays = () => {
  const [users, setUsers] = useState([
    {
      id: 1,
      Title: "Project 1",
      HolidayDate: "2024-01-01",
      CreatedBy: "Admin",
    },
  ]);

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState(users);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    const filteredData = users.filter((user) =>
      user.Title.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredUsers(filteredData);
  };

  const navigate = useNavigate();

  const handleOpenClick = () => {
    navigate("/cluster-creations"); // Navigate to the dynamic route with project ID
  };

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Project Name",
      dataIndex: "Title",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.Title - b.Title,
    },
    // {
    //   title: "Date Created",
    //   dataIndex: "HolidayDate",
    //   render: (text) => <span>{text}</span>,
    //   sorter: (a, b) => a.Title.length - b.Title.length,
    // },
    {
      title: "Created By",
      dataIndex: "CreatedBy",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.Title.length - b.Title.length,
    },
    {
      title: "Open",
      dataIndex: "chk",
      render: (text, record) => (
        <>
          <span>{text}</span>
          <button
            type="button"
            className="btn btn-success me-2"
            onClick={() => handleOpenClick(record)}
          >
            Open
          </button>
        </>
      ),
      sorter: (a, b) => a.HolidayDate.length - b.HolidayDate.length,
    },

    {
      title: "Action",
      render: () => (
        <div className="dropdown dropdown-action ">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#edit_holiday"
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete"
            >
              <i className="fa-regular fa-trash-can m-r-5" /> Delete
            </Link>
          </div>
        </div>
      ),
      sorter: true,
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Monthly Consumption Usage Profile"
            title="Dashboard"
            modal="#add_holiday"
            name="Add Project"
          />

          <div className="d-flex justify-content-start mb-3">
            <Input
              placeholder="Search Project"
              value={searchTerm}
              onChange={handleSearch}
              style={{ width: "25%" }}
            />
          </div>

          {/* /Page Header */}
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={filteredUsers.map((user, index) => ({
                    key: index,
                    id: user.id,
                    Title: user.Title,
                    HolidayDate: user.HolidayDate,
                    CreatedBy: user.CreatedBy,
                  }))}
                  className="table-striped"
                  rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
      <AddHoliday />
      <DeleteModal Name="Delete Project" />
    </>
  );
};

export default Holidays;

// import { Table, Input } from "antd";
// import { AddHoliday } from "../../../components/modelpopup/AddHoliday";
// import { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import DeleteModal from "../../../components/modelpopup/DeleteModal";
// import Breadcrumbs from "../../../components/Breadcrumbs";

// const Holidays = () => {
//   const [users, setUsers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filteredUsers, setFilteredUsers] = useState([]);

//   useEffect(() => {
//     const savedUsers = JSON.parse(localStorage.getItem("holidays")) || [
//       {
//         id: 1,
//         Title: "Project 1",
//         HolidayDate: "2024-01-01",
//         CreatedBy: "Admin",
//       },
//     ];
//     setUsers(savedUsers);
//     setFilteredUsers(savedUsers);
//   }, []);

//   const handleAddProject = (newProject) => {
//     const updatedUsers = [...users, newProject];
//     setUsers(updatedUsers);
//     setFilteredUsers(updatedUsers);
//     localStorage.setItem("holidays", JSON.stringify(updatedUsers));
//   };

//   const handleSearch = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     const filteredData = users.filter((user) =>
//       user.Title.toLowerCase().includes(value.toLowerCase())
//     );
//     setFilteredUsers(filteredData);
//   };

//   const navigate = useNavigate();

//   const columns = [
//     {
//       title: "Project Name",
//       dataIndex: "Title",
//       sorter: (a, b) => a.id - b.id,
//     },
//     {
//       title: "Date Created",
//       dataIndex: "HolidayDate",
//       sorter: (a, b) => a.Title.length - b.Title.length,
//     },
//     {
//       title: "Created By",
//       dataIndex: "CreatedBy",
//       sorter: (a, b) => a.Title.length - b.Title.length,
//     },
//     {
//       title: "Open",
//       dataIndex: "chk",
//       render: (text, record) => (
//         <button
//           type="button"
//           className="btn btn-success me-2"
//           onClick={() => navigate("/cluster-creations")}
//         >
//           Open
//         </button>
//       ),
//       sorter: (a, b) => a.HolidayDate.length - b.HolidayDate.length,
//     },
//     {
//       title: "Action",
//       render: () => (
//         <div className="dropdown dropdown-action">
//           <Link
//             to="#"
//             className="action-icon dropdown-toggle"
//             data-bs-toggle="dropdown"
//           >
//             <i className="material-icons">more_vert</i>
//           </Link>
//           <div className="dropdown-menu dropdown-menu-right">
//             <Link className="dropdown-item" to="#">
//               <i className="fa fa-pencil m-r-5" /> Edit
//             </Link>
//             <Link className="dropdown-item" to="#">
//               <i className="fa-regular fa-trash-can m-r-5" /> Delete
//             </Link>
//           </div>
//         </div>
//       ),
//       sorter: true,
//     },
//   ];

//   return (
//     <div className="page-wrapper">
//       <div className="content container-fluid">
//         <Breadcrumbs
//           maintitle="Monthly Consumption Usage Profile"
//           title="Dashboard"
//           modal="#add_holiday"
//           name="Add Project"
//         />
//         <div className="d-flex justify-content-start mb-3">
//           <Input
//             placeholder="Search Project"
//             value={searchTerm}
//             onChange={handleSearch}
//             style={{ width: "25%" }}
//           />
//         </div>
//         <div className="row">
//           <div className="col-md-12">
//             <div className="table-responsive">
//               <Table
//                 columns={columns}
//                 dataSource={filteredUsers.map((user) => ({
//                   key: user.id,
//                   ...user,
//                 }))}
//                 className="table-striped"
//                 rowKey={(record) => record.id}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//       <AddHoliday onAddProject={handleAddProject} />
//       <DeleteModal Name="Delete Holiday" />
//     </div>
//   );
// };

// export default Holidays;
